<template>
	<div
		v-if="productHasAttributes"
		class="col-xxs-12 col-sm-6"
	>
		<div
			v-for="addon in addons"
			:key="addon.key"
			class="active-product__attribute-group"
		>
			<h4 class="active-product__attribute__title">{{ addon.title }}</h4>
			<ul class="active-product__attributes">
				<li
					v-for="option in addon.options"
					:key="option.key"
					class="active-product__attribute"
				>
					<label
						:for="getAddonKey( addon.key, option.key )"
						class="active-product__attribute__label"
					>
						<input
							@change="$emit( 'set_active_addon', addon.key, option.key )"
							:checked="option.active"
							:id="getAddonKey( addon.key, option.key )"
							type="checkbox"
							class="active-product__attribute__input input-choice input-choice--checkbox"
						/>
						<span class="active-product__attribute__value input-choice-value input-choice-value--checkbox">
							{{ option.title }}
						</span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>


<script>
	import _isEmpty from 'lodash.isempty'


	export default {
		name: 'ProductAddonGroup',
		props: {
			id: {
				type: Number,
				required: true,
			},
			addons: {
				type: [ Object, Array ],
				required: true,
			},
		},

		methods: {
			getAddonKey( addonKey, optionKey ) {
				return `${this.id}_${addonKey}_${optionKey}`
			},

			productHasAttributes() {
				return !_isEmpty( this.addons )
			},
		},	
	}
</script>